import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Emergency handler to remove splash screen if app crashes globally before mount
window.addEventListener('error', () => {
  const splash = document.getElementById('static-splash-wrapper');
  if (splash) {
    splash.remove();
    document.body.style.backgroundColor = '#ffffff';
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register service worker lazily after page loads to avoid any performance impact during initial load or testing
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        console.log('[PWA] Service Worker registered successfully with scope:', reg.scope);
      })
      .catch((err) => {
        console.error('[PWA] Service Worker registration failed:', err);
      });
  });
}

